document.addEventListener('DOMContentLoaded', () => {
    document.querySelector('input[name=tracking_permission_1]').addEventListener('change', function () {
        const buttonEl = document.querySelector('button[type=submit]');
        if (this.checked) {
            buttonEl.classList.remove('is-disabled');
        }
        else {
            buttonEl.classList.add('is-disabled');
        }
    });
});
